import { define } from 'remount'
import TopMenu from './top-menu'
import MegaMenu from './mega-menu'
import Slideshow from './slideshow'
import DayPicker from './day-picker'
import EventBooking from './events/booking'
import EventStrip from './event-strip'
import OtherEventsList from './other-events-list'
import WhatsOn from './whatson'
import Search from './search'
import ArrayField from './admin/settings/array-field'
import IntegerField from './admin/settings/integer-field'
import CategoryInput from './admin/events/category-input'
import BasketStatus from './basket-status'
import InstanceBookingButton from './instance/booking-button'
import BasketView from './basket-view'
import WysiwygEditor from './admin/shared/wysiwyg-editor'
import ImageCropEditor from './admin/shared/image-crop-editor'
import CopyUrlButton from './admin/shared/copy-url-button'
import VideoUrlInput from './admin/shared/video-url-input'
import ImagePreview from './admin/shared/image-preview'
import InstanceManager from './admin/events/instance-manager'
import WysiwygWithUpload from './admin/events/wysiwyg-with-upload'
import GiftVoucher from './gift-voucher'
import MenuEditor from './admin/menus/menu-editor'
import UpcomingEventsStrip from './admin/dashboard/upcoming-events-strip'
import Memberships from './memberships'
import LoginModal from './login-modal'
import PriorityBookingHandler from './priority-booking'
import EnhancedPriorityBookingHandler from './priority-booking/enhanced-handler'
import PriorityBookingLoginPrompt from './priority-booking/login-prompt'
import PriorityBookingMembershipRequired from './priority-booking/membership-required'
import PriorityBookingErrorModal from './priority-booking/error-modal'
import PreSalePrompt from './priority-booking/pre-sale-prompt'
import UserMenu from './user-menu'
import MyAccount from './my-account'


define({
  'nfca-top-menu': {
    component: TopMenu
  },
  'nfca-mega-menu': {
    component: MegaMenu
  },
  'nfca-slideshow': {
    component: Slideshow
  },
  'nfca-day-picker': {
    component: DayPicker,
    attributes: ['defaultDate']
  },
  'nfca-event-booking': {
    component: EventBooking,
    attributes: ['event-data', 'instance-data']
  },
  'nfca-event-strip': {
    component: EventStrip
  },
  'nfca-other-events-list': {
    component: OtherEventsList,
    attributes: ['date', 'exclude-event']
  },
  'nfca-whatson': {
    component: WhatsOn
  },
  'nfca-search': {
    component: Search
  },
  'nfca-admin-array-field': {
    component: ArrayField,
    attributes: ['setting', 'initial-value', 'placeholder', 'validation-type']
  },
  'nfca-admin-integer-field': {
    component: IntegerField,
    attributes: ['setting', 'initial-value', 'min', 'max']
  },
  'nfca-admin-category-input': {
    component: CategoryInput,
    attributes: ['initialCategories', 'allCategories']
  },
  'nfca-basket-status': {
    component: BasketStatus,
    attributes: ['className', 'iconOnly']
  },
  'nfca-instance-booking-button': {
    component: InstanceBookingButton,
    attributes: ['instanceId', 'eventSlug', 'eventName', 'dateSlug', 'timeSlug', 'dateTimeSlug', 'isFree', 'isOnSale', 'isLocked', 'available', 'limitedAvailability', 'parentAndBaby', 'priorityBookingStartsAt']
  },
  'nfca-basket-view': {
    component: BasketView,
    attributes: ['dataOffers']
  },
  'nfca-admin-wysiwyg-editor': {
    component: WysiwygEditor,
    attributes: ['initialContent', 'hiddenFieldId', 'placeholder', 'height', 'downloadableType', 'downloadableId']
  },
  'nfca-admin-image-crop-editor': {
    component: ImageCropEditor,
    attributes: ['image-src', 'field-prefix', 'original-width', 'original-height', 'crop-data']
  },
  'nfca-add-gift-voucher': {
    component: GiftVoucher
  },
  'nfca-admin-copy-url-button': {
    component: CopyUrlButton,
    attributes: ['url', 'buttonText']
  },
  'nfca-admin-video-url-input': {
    component: VideoUrlInput,
    attributes: ['initialUrl', 'videoServiceFieldId', 'videoIdFieldId', 'inputId']
  },
  'nfca-admin-image-preview': {
    component: ImagePreview,
    attributes: ['fileInputId', 'previewType', 'existingImageUrl', 'existingImageAlt']
  },
  'nfca-admin-instance-manager': {
    component: InstanceManager,
    attributes: ['initialInstances']
  },
  'nfca-admin-wysiwyg-with-upload': {
    component: WysiwygWithUpload,
    attributes: ['initialContent', 'hiddenFieldId', 'placeholder', 'height']
  },
  'nfca-admin-menu-editor': {
    component: MenuEditor
  },
  'nfca-admin-upcoming-events-strip': {
    component: UpcomingEventsStrip
  },
  'nfca-memberships': {
    component: Memberships
  },
  'nfca-login-modal': {
    component: LoginModal,
    attributes: ['isOpen', 'onClose', 'onLoginSuccess']
  },
  'nfca-priority-booking-handler': {
    component: PriorityBookingHandler,
    attributes: ['event', 'instance']
  },
  'nfca-priority-booking-login-prompt': {
    component: PriorityBookingLoginPrompt,
    attributes: ['eventName', 'onLoginSuccess']
  },
  'nfca-priority-booking-membership-required': {
    component: PriorityBookingMembershipRequired,
    attributes: ['eventName']
  },
  'nfca-priority-booking-error-modal': {
    component: PriorityBookingErrorModal,
    attributes: ['isOpen', 'onClose', 'eventName']
  },
  'nfca-enhanced-priority-booking-handler': {
    component: EnhancedPriorityBookingHandler,
    attributes: ['event', 'instance']
  },
  'nfca-pre-sale-prompt': {
    component: PreSalePrompt,
    attributes: ['eventName', 'instanceStartSellingAt', 'onLoginSuccess', 'onPromoCodeSuccess']
  },
  'nfca-user-menu': {
    component: UserMenu,
    attributes: ['authState']
  },
  'nfca-my-account': {
    component: MyAccount
  }

})
